import { useEffect, useState } from 'react';
import { Api } from '../../../componentes/Api';
import { Card, CardBody,Row,Col, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter  } from "reactstrap"

import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";
const modeloDatos = {
   almacenID: 0, 
    empresaID: "",
    descripcion: "",
    ubicacionID: 1,
    activo:true,
    creadoPor: "",
    modificadoPor: "",
    fechaCreado: new Date,
    fechaModificado: new Date
   
}

const InformesVentas = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [Listado, SetListado] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);

    const handleChange = (e) => {
        let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTabla({
            ...tabla,
            [e.target.name]: value
        })
    }


    const obtenerDatos = async () => {
        let response = await fetch(Api + "VentasMantenimiento/listaAlmacen");

        if (response.ok) {
            let data = await response.json()
            SetListado(data)
            setPendiente(false)
        }
    }

    useEffect(() => {
        obtenerDatos();
    })


    const guardarCambios = async () => {
        tabla.empresaId = "PR";

        let response;
        if (tabla.almacenID == 0) {
          
            response = await fetch(Api + "VentasMantenimiento/GuardarAlmacen", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })

        } else {
            response = await fetch(Api + "VentasMantenimiento/EditarAlmacen", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
        }

        if (response.ok) {
            await obtenerDatos();
            setTabla(modeloDatos)
            setVerModal(!verModal);
            Swal.fire(
                'Guardado!',
                '',
                'success'
            )
        } else {
            alert("error al guardar")
        }

    }

    const eliminarDatos = async (id) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea eliminar el producto",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.value) {

                const response = fetch(Api + "evaluaciondesempeno/EliminarPregunta/" + id, { method: "DELETE" })
                    .then(response => {
                        if (response.ok) {

                            obtenerDatos();

                            Swal.fire(
                                'Eliminado!',
                                'El producto fue eliminado.',
                                'success'
                            )
                        }
                    })
            }
        })
    }

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
    }

    const columns = [
        {
            name: 'ID',
            selector: row => row.almacenID,
            sortable: true,
        },
        {
            name: 'Descripcion',
            selector: row => row.descripcion,
            sortable: true,
        },
       
       
        //{
        //    name: 'Estado',
        //    selector: row => row.esActivo,
        //    sortable: true,
        //    cell: row => {
        //        let clase;
        //        clase = row.esActivo ? "badge badge-info p-2" : "badge badge-danger p-2"
        //        return (
        //            <span className={clase}>{row.esActivo ? "Activo" : "No Activo"}</span>
        //        )
        //    }
        //}
        ,
        {
            name: '',
            cell: row => (
                <>
                    <Button color="primary" size="sm" className="mr-2"
                     onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>

                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };




    const CuadreCajaPV = () => {
        window.open("/CuadreCajaPV" , '_blank');
    }
    const CuadreCajaNCF = () => {
        window.open("/CuadreCajaNCF" , '_blank');
    }

    const navigate = useNavigate();
    const handleNavigate = () => {
        navigate("/ImpresionVentas/1", { state: { myData: "http://tool.apatech.com.do/api/VentasTrans/HistorialFactura/fecha/2024-01-01/2024-12-23" } });
    };

    return (
        <>
            <div class="reporting-container">
                <button class="report-button sales" onClick={() => CuadreCajaPV() } >
                    <i class="fas fa-chart-line"></i> Cuadre Caja Punto Venta
                </button>
                <button class="report-button inventory" onClick={() => CuadreCajaNCF()}>
                    <i class="fas fa-boxes"></i>  Cuadre Caja NCF
                </button>
           
            </div>
        </>
        )

}
export default InformesVentas;